export default {
  headers: {
    edit_time: "Modifier l'horaire",
    create_time: 'Créer un horaire',
  },
  labels: {
    select_all: 'Tout sélectionner',
  },
  buttons: {
    add_opening_time: "Ajouter un horaire d'ouverture",
    add: 'Ajouter',
    cancel: 'Annuler',
  },
};
